// viewBox of the full logo and of the infinity mark alone.
export const LOGO_VIEWS = { full: "0 0 616 134", mark: "16 14 224 106" } as const;
